import { render, staticRenderFns } from "./Resolve.vue?vue&type=template&id=773ffaba&scoped=true"
import script from "./Resolve.vue?vue&type=script&lang=js"
export * from "./Resolve.vue?vue&type=script&lang=js"
import style0 from "./Resolve.vue?vue&type=style&index=0&id=773ffaba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../Development/QC/qcheck-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "773ffaba",
  null
  
)

export default component.exports